// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__2RcbS","fullWidthRoot":"Container_fullWidthRoot__2iKxw"};